import { DetailedHTMLProps, HTMLAttributes } from 'react'
import { cn } from '@scalis/utils'

export const Icon = ({ className, ...props }: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) => {
  return (
    <i
      aria-hidden
      className={cn(
        'relative size-6 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2',
        className,
      )}
      {...props}
    />
  )
}
